module.exports = __webpack_public_path__ + "img/1286632520.a801dba7.jpg";